import React from 'react';
import withIcon from '../utilities/withIcon';

const IconFlag = () => {
  return (
    <g>
      <path d="M1.75 0a.75.75 0 0 1 .744.648l.007.102C3.258.402 4.183.23 5.266.23c1.018 0 1.686.254 2.861.953l.475.287.386.224c.721.402 1.154.536 1.737.536 1.303 0 2.321-.289 3.076-.851a.751.751 0 0 1 1.192.495L15 1.98v7a.75.75 0 0 1-.302.601c-1.034.771-2.366 1.149-3.973 1.149-1.018 0-1.687-.254-2.861-.953l-.475-.287-.387-.224c-.72-.403-1.153-.536-1.736-.536-1.28 0-2.192.278-2.765.8v5.721a.75.75 0 0 1-1.494.102L1 15.25V.75A.75.75 0 0 1 1.75 0zm3.516 1.73c-1.28 0-2.192.278-2.765.8v5.225c.757-.353 1.682-.525 2.765-.525 1.018 0 1.686.254 2.861.953l.475.287.386.224c.721.402 1.154.536 1.737.536 1.103 0 2.001-.207 2.709-.611l.065-.041V3.247l-.183.072c-.677.244-1.436.379-2.273.406l-.318.005c-1.018 0-1.687-.254-2.861-.953l-.475-.287-.387-.224c-.72-.403-1.153-.536-1.736-.536z" />
    </g>
  );
};

export default withIcon(IconFlag);
